import {userSelector} from "@/redux/user/userSelector";
import {useSelector} from "react-redux";
import {useAuth0} from "@auth0/auth0-react";

export const useUserInfo = () => {
    const {userData} = useSelector(userSelector);
    const {user, logout} = useAuth0();

    // console.log(userData)

    const logoutUser = async () => {
        //Auth0 version > 2.0.0
        // await logout({
            // logoutParams: {
            //     returnTo: window.location.origin
            // }
        // });
        //Auth0 version 1.12.0
        logout({ returnTo: window?.location?.origin });
    }

    return {
        userData,
        user,
        logout: logoutUser,
    }
}